import React, { useEffect, useState } from "react";
import AdSense from "react-adsense";

const GoogleAds = ({ width, height, refreshTime = 0 }) => {
  width = width > 0 ? width : 300;
  height = height > 0 ? height : 600;

  const [refresh, setRefresh] = useState(false);
  const [shouldRender, setShouldRender] = useState(false); /* added on 17/6/2025 to prevent javascript error of google ads */

  useEffect(() => {
    const delayRender = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      setShouldRender(true);
    };

    delayRender();
  }, []);

  useEffect(() => {
    if (refreshTime > 0) {
      const refreshInterval = setInterval(() => {
        setRefresh(true);
      }, refreshTime);
      return () => {
        clearInterval(refreshInterval);
        setRefresh(false);
      };
    }
  }, [refresh]);

  useEffect(() => {
    let wrapper = document.getElementById('root')
    const observer = new MutationObserver(function (mutations, observer) {
      wrapper.style.height = ''
      wrapper.style.minHeight = ''
    })
    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['style']
    })


    let wrapper2 = document.getElementsByClassName('chatAppRoot')[0];
    const observer2 = new MutationObserver(function (mutations, observer2) {
      wrapper2.style.height = ''
      wrapper2.style.minHeight = ''
    })
    observer2.observe(wrapper2, {
      attributes: true,
      attributeFilter: ['style']
    })

    let wrapper3 = document.getElementsByClassName('chatAppWrap')[0];
    const observer3 = new MutationObserver(function (mutations, observer3) {
      wrapper3.style.height = ''
      wrapper3.style.minHeight = ''
    })
    observer3.observe(wrapper2, {
      attributes: true,
      attributeFilter: ['style']
    })

    let wrapper4 = document.getElementsByClassName('chatAppContainer')[0];
    const observer4 = new MutationObserver(function (mutations, observer4) {
      wrapper4.style.height = ''
      wrapper4.style.minHeight = ''
    })
    observer4.observe(wrapper4, {
      attributes: true,
      attributeFilter: ['style']
    })

    return () => {
      /*
      observer.disconnect();
      observer2.disconnect();
      observer3.disconnect();
      observer4.disconnect();
      */
    }
  }, []);

  let content = (
    <AdSense.Google
      client="ca-pub-3319273081114067"
      slot="1813346434"
      style={{ width: width, height: height }}
      format=""
    />
  );

  if (refresh) {
    content = <div>...</div>;
  }

  return shouldRender ? content : null;
};

export default GoogleAds;
